import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueJsonp from 'vue-jsonp'
import './registerServiceWorker';

Vue.config.productionTip = false;
import 'swiper/dist/css/swiper.css';
Vue.use(VueJsonp)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
